import { useTranslation } from "@opendash/i18n";
import { Descriptions, Flex, Input, Typography } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import React, { useEffect } from "react";
import { useHideOnPrint } from "../hooks/useHideOnPrint";

export const UserNoticeTile = () => {
  const [notice, setNotice] = React.useState<string>("");
  const { className, icon, toggleIsVisible, isVisible, title } = useHideOnPrint(
    false,
    true
  );
  const t = useTranslation();

  const items: DescriptionsItemType[] = [
    {
      key: 4,
      span: 100,
      className: className,
      label: (
        <Flex
          gap="2vw"
          align="center"
          onClick={() => toggleIsVisible()}
          title={title}
          style={{ cursor: "pointer", userSelect: "none" }}
        >
          <Typography.Text>
            {t(
              "maintenance:monitor.daily_schedule.print.ticket.user_notice.label"
            )}
          </Typography.Text>
          {icon}
        </Flex>
      ),

      children: (
        <Input.TextArea
          onChange={(e) => setNotice(e.target.value)}
          placeholder={t(
            "maintenance:monitor.daily_schedule.print.ticket.user_notice.placeholder"
          )}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!notice && isVisible) toggleIsVisible();
    else if (notice && !isVisible) toggleIsVisible();
  }, [notice]);

  return (
    <Descriptions
      column={100}
      layout="vertical"
      bordered
      size="small"
      items={items}
      className={className}
    />
  );
};
